import { _axios } from "../axios";
import { AxiosResponse } from "axios";
import moment from 'moment';

const timeslotsResource = '/timeslots';

/**
 *
 * @param date
 * @returns {AxiosResponse<T>}
 */
export function getSlots(date = null) {
    if (!date) {
        date = moment.now().toJSON();
    }

    return _axios.get(`${timeslotsResource}/${date}`);
}

/**
 *
 * @param slotId
 * @param data
 * @returns {AxiosResponse<T>}
 */
export function reserveSlot(slotId, data = {}) {
    return _axios.put(`${timeslotsResource}/${slotId}/reserve`, data);
}

/**
 *
 * @param slotId
 * @param saleId
 * @returns {AxiosResponse<T>}
 */
export function bookSlot(slotId, saleId) {
    return _axios.post(`${timeslotsResource}/${slotId}/book`, {saleId: saleId});
}

/**
 *
 * @param slotId
 * @returns {AxiosResponse<T>}
 */
export function releaseSlot(slotId) {
    return _axios.delete(`${timeslotsResource}/${slotId}/release`);
}